import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { ArrowLeftIcon, GraduationCapIcon, PhoneCallIcon, HandshakeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidJessePage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2828" data-mp="2qpfbds70hsge">
      <SEO title="Jesse Put, Junior Sales Executive | Noord Digital" description="Maak kennis met Jesse Put, Junior Sales Executive bij Noord Digital. Loopt stage om het sales-vak te leren van Rocco en Jelle." canonical="https://noorddigital.nl/over-ons/jesse" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Jesse Put',
      path: '/over-ons/jesse'
    }])} data-id="element-2829" data-mp="2ur0tbryekwxg" />
      <Header data-id="element-2830" data-mp="1ad05m5qkjjqh" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2831" data-mp="1acgy7iyjodqp">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2832" data-mp="3b8yw381ofv8o">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2833" data-mp="3baiaet3rvw7t">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2834" data-mp="31huf62sfy0b7" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2835" data-mp="2xhk9ysch3dxe">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2836" data-mp="3u7b5muwi374s">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5]" data-id="element-2837" data-mp="3u574ultweo8q">
                <img src="https://cdn.magicpatterns.com/uploads/8MJF64emYA1SRDFsWSY2N8/Norden_Jesse_put.png" alt="Jesse Put" className="w-full h-full object-cover" data-id="element-2838" data-mp="3l5k4m3cwnoh9" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2839" data-mp="29s7u59mn47m4">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2840" data-mp="29p3ijr6ui9lf">
                Jesse Put
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2841" data-mp="269sb0gf1tzt4">
                Junior Sales Executive
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2842" data-mp="2b7k8dpygqe4p">
                <p className="mb-4" data-id="element-2843" data-mp="1x942u2cc6to5">
                  Als Junior Sales Executive loop ik stage bij Noord Digital om
                  het sales-vak in de praktijk te leren. Ik werk nauw samen met
                  Rocco en Jelle, kijk mee in gesprekken en pak gaandeweg meer
                  zelfstandig op.
                </p>
                <p className="mb-4" data-id="element-2844" data-mp="1sasslqi4qh5e">
                  Mijn rol is vooral leren door te doen: voorbereiden,
                  meeluisteren, opvolgen en de juiste vragen leren stellen. Geen
                  scripts, wel oprecht nieuwsgierig naar wat er bij jouw bedrijf
                  speelt.
                </p>
                <p data-id="element-2845" data-mp="14kos3s08mxim">
                  Een frisse blik kan helpen. Ik stel soms net die ene vraag die
                  een ander vergeet, en dat levert vaak het scherpste inzicht op
                  voor een passend voorstel.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2846" data-mp="kz6hu5i337fr">
                Expertise in ontwikkeling
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2847" data-mp="yzpl6zbltpbl">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2848" data-mp="uvhsys5xtr8m">
                  <GraduationCapIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2849" data-mp="18vk9a9ylkclr" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2850" data-mp="13xiq7p168daa">Stage in sales</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2851" data-mp="1ilvpovzgwe9j">
                  <PhoneCallIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2852" data-mp="1inyg3h4j89es" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2853" data-mp="1dnu5g7qb28wh">Eerste contact</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2854" data-mp="1rn3967xbrajk">
                  <HandshakeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2855" data-mp="1mpbkdmrz84jl" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2856" data-mp="3h4qq3gb8bs2m">Opvolging</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2857" data-mp="3m1qwxtfwkyus">
                Neem contact op met Jesse
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2858" data-mp="2y5uy8bmufpry" />
    </div>;
};